// @flow
import React from "react"
import { compose, type HOC } from "recompose"
import withOpen from "hoc/withOpen"
import withUser from "hoc/withUser"
import withConnect from "hoc/withConnect"
import urls from "data/router/urls"
import { logout } from "data/user/actions"
import { selectPrimary } from "data/user/helpers"
import Avatar from "components/Avatar"
import ContextMenu from "components/ContextMenu"
import OverlayWrapper from "components/OverlayWrapper"
import ArrowIcon from "assets/icons/ArrowIcon"
import { Toggle, MenuLinks, MenuLink } from "./styled"

const AvatarMenu = ({ close, toggleOpen, isOpen, user, logout }) => {
  const rotationCondition = isOpen ? "up" : undefined
  return (
    <OverlayWrapper isOpen={isOpen} close={close}>
      <Toggle open={isOpen} onClick={toggleOpen} isSelected={isOpen}>
        <Avatar profile={selectPrimary(user)} />
        <ArrowIcon marginLeft rotation={rotationCondition} />
      </Toggle>
      <ContextMenu isOpen={isOpen} close={close}>
        <MenuLinks>
          <MenuLink to={urls.account.index} onClick={close}>Account</MenuLink>
          <MenuLink onClick={logout}>Logout</MenuLink>
        </MenuLinks>
      </ContextMenu>
    </OverlayWrapper>
  )
}
const enhancer: HOC<*, {}> = compose(
  withUser(),
  withOpen,
  withConnect(() => ({}), { logout }),
)

export default enhancer(AvatarMenu)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/AvatarMenu/index.js